module.exports = __webpack_public_path__ + "static/media/eye_open.ce50afc3.svg";